import {DevicesTypes} from '../types/devices.types';


export namespace DevicesConstants {

  import deviceType = DevicesTypes.deviceType;
  export const DEVICE_TYPE_LIRIS_V2: deviceType = {
    id: 1,
    key: 'liris_v2'
  };

  export const DEVICE_TYPE_INCLINO_V2: deviceType = {
    id: 5,
    key: 'inclino_v2'
  };

  export const DEVICE_TYPE_LIRIS_V3: deviceType = {
    id: 6,
    key: 'liris_v3'
  };

  export const DEVICE_TYPE_SPCU_V5: deviceType = {
    id: 11,
    key: 'spcu_v5'
  };

  export const DEVICE_TYPE_INCLINO_BI_AXIS: deviceType = {
    id: 14,
    key: 'inclinobiaxis'
  };

  export const DEVICE_TYPE_G_SENSOR: deviceType = {
    id: 16,
    key: 'g _sensor'
  };

  export const DEVICE_TYPE_EXTEG: deviceType = {
    id: 17,
    key: 'exteg'
  };

  export const DEVICE_LIRIS_420_V3: deviceType = {
    id: 18,
    key: 'liris_420_v3'
  };

  export const DEVICE_EXPE: deviceType = {
    id: 19,
    key: 'expe'
  };

  export const DEVICE_TYPES_FOR_ALARMS: deviceType[] = [
    DEVICE_TYPE_LIRIS_V2,
    DEVICE_TYPE_INCLINO_V2,
    DEVICE_TYPE_LIRIS_V3,
    DEVICE_TYPE_SPCU_V5,
    DEVICE_TYPE_INCLINO_BI_AXIS,
    DEVICE_TYPE_G_SENSOR,
    DEVICE_TYPE_EXTEG,
    DEVICE_LIRIS_420_V3,
    DEVICE_EXPE
  ];
}
